import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, Ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  ConclusionStep,
  ContentDisplay,
  Heading,
  ListDisplay,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';

import { IInvestmentDetails } from '@/modules/transaction/services/variable-income';


export default /*#__PURE__*/_defineComponent({
  __name: 'Conclusion',
  setup(__props) {

const router = useRouter();

const portfolioId = inject('portfolioId') as Ref<string>;
const amountFormatted = inject('amountFormatted') as Ref<string>;

const investmentDetails = inject(
  'investmentDetails'
) as Ref<IInvestmentDetails>;

const description = computed(() => {
  return `Execução da carteira prevista para ${investmentDetails.value.expectedInvestmentDate}`;
});

const details = computed(() => {
  return [
    {
      label: 'Nome',
      value: investmentDetails.value.portfolioName
    },
    {
      label: 'Total investido',
      value: `R$ ${amountFormatted.value}`
    },
    {
      label: 'Tipo de gestão',
      value: 'Warren'
    }
  ];
});

function goToPortfolio() {
  router.push({
    name: 'wealthIndexPortfolio',
    params: { portfolioId: portfolioId.value }
  });
}

return { __sfc: true,router, portfolioId, amountFormatted, investmentDetails, description, details, goToPortfolio, ConclusionStep, ContentDisplay, Heading, ListDisplay, ButtonPrimary }
}

})